import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
	selector: '[qeBaseButton]',
})
export class BaseButtonDirective {
	@Input() public color: 'primary'|'accent'|'warn' = 'primary';
	@Input('button-type') public type: 'flat'|'confirm'|'raised'|'ghost'|'minimal' = 'minimal';

	constructor() {

	}

	@HostBinding('class')
	public get buttonTheme(): string {
		return `m--${this.color} m--${this.type}`;
	}
}
